import * as React from 'react'
import { Layout, LayoutProps } from 'react-admin'
import MyAppBar from './AppBar'

const MyLayout = (props: LayoutProps): JSX.Element => <Layout {...props} appBar={MyAppBar} />

export default MyLayout
